import React, { useMemo, useCallback } from 'react';
import { Typography, Grid } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';

import CheckboxItem from 'common/components/CheckboxItem';
import useDebouncedForm from 'common/hooks/useDebouncedForm';

import ContainerBox from 'components/ContainerBox';
import * as ActiveProductActions from 'actions/ActiveProductActions';
import * as ActiveProductSelectors from 'selectors/ActiveProductSelectors';
import HasFeature from 'components/features/HasFeature';
import { useTranslation } from 'services/localization/useTranslation';

const Integrations = () => {
	const dispatch = useDispatch();
	const product = useSelector(ActiveProductSelectors.productDataWithChanges);
	const isEditingDisabled = useSelector(ActiveProductSelectors.isEditingDisabled);
	const { t } = useTranslation();

	const { state, editState } = useDebouncedForm({
		memoizedInitialState: useMemo(
			() => ({
				offerLiftTickets: product?.offerLiftTickets ?? false,
			}),
			[product],
		),
		memoizedOnDebounce: useCallback(
			(changes) => {
				dispatch(ActiveProductActions.editLocalProduct(changes));
			},
			[dispatch],
		),
	});

	return (
		<HasFeature requiredFeature="SKIDATA">
			<ContainerBox>
				<Typography variant="h6" gutterBottom>
					{t('product.integrations', 'Integrations')}
				</Typography>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<Typography variant="body1">{'SKIDATA'}</Typography>
						<CheckboxItem
							label={t(
								'product.integrationsOfferLiftTickets',
								'Offer lift tickets with this product',
							)}
							description={t(
								'product.integrationsOfferLiftTicketsHelper',
								'If yes, lift tickets will be offered as additional products for rentals containing this product (Online only)',
							)}
							checked={state.offerLiftTickets}
							onCheckedChange={(offerLiftTickets) => editState({ offerLiftTickets })}
							disabled={isEditingDisabled}
						/>
					</Grid>
				</Grid>
			</ContainerBox>
		</HasFeature>
	);
};

export default Integrations;
